import { AdNetworkResponse, UploadFormData } from "../../model/ani"
import { api } from "./api"

const API_URL = import.meta.env.VITE_ANI_API_URL

export const addNetworkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllNetworks: build.query<AdNetworkResponse, void>({
      query: () => `${API_URL}/upload_assets/networks`,
    }),
    uploadAssetToNetworks: build.mutation<void, FormData>({
      query: (formData) => {
        return {
          url: `${API_URL}/upload_assets`,
          method: "POST",
          body: formData,
        }
      },
      invalidatesTags: () => [{ type: "Tags" }],
    }),
  }),
})

export const { useGetAllNetworksQuery, useUploadAssetToNetworksMutation } =
  addNetworkApi

export const {
  endpoints: { getAllNetworks, uploadAssetToNetworks },
} = addNetworkApi
